import AddAssets from './addAssets'
export default AddAssets
